import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./OurServices.css"; 
  import Img1 from '../../images/Image-1.jpg'
  import Img2 from '../../images/Image-2.jpg'
  import Img3 from '../../images/Image-3.jpg'
  import Img4 from '../../images/Image-4.jpg'
  import Img5 from '../../images/Image-5.jpg'
  import Img6 from '../../images/Image-6.jpg'
  import care1 from '../../images/Homecare.jpg'
  import care2 from '../../images/ToSellCareHome.jpg'
  import Acco1 from '../../images/Accounts-1.jpg'
  import Acco2 from '../../images/ToSellCareHome.jpg'
  import Acco3 from '../../images/Allowances.jpg'
  import Acco4 from '../../images/FinancialAnalysis.jpg'
  import Soft1 from '../../images/rotacare.jpg'
  import Soft2 from '../../images/Governance Software.jpg'
  import Soft3 from '../../images/Care Audit Software.jpg'
  import Soft4 from '../../images/Our ERP System.jpg'
  import Soft5 from '../../images/Capital allowances.jpg'
  import Opra1 from '../../images/New Business Set Up.jpg'
  import Opra2 from '../../images/Full Operational Management.jpg';




const Services = () => {

  const handleSeeMore = () => {
    navigate("/", {
      state: { scrollToContact: true },
    });
  };


const scrollToSection = (sectionId) => {
  setActiveSection(sectionId);

  setTimeout(() => {
    const section = document.getElementById(sectionId);

    if (section) {
      section.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }, 100);
};


    // open page on top //
   useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
  
    // open page on top // 

const navigate = useNavigate();

const navigateToService = (section) => {
  navigate("/services", {
    state: {
      activeSection: section,
    },
  });
};

 const handleReadMoreCQ1 = () => {
    navigate("/registration");
  };
   const handleReadMoreCQ2 = () => {
    navigate("/Sub-Pages/CQC_Mock");
  };
   const handleReadMoreCQ3 = () => {
    navigate("/Sub-Pages/CQC_Support");
  };
   const handleReadMoreCQ4 = () => {
    navigate("/Sub-Pages/CQC_Occupancy");
  };
   const handleReadMoreCQ5 = () => {
    navigate("/Sub-Pages/CQC_Training");
  };
  const handleReadMoreCA1 = () => {
  navigate("/Sub-Pages/Care_Sale");
  };
   const handleReadMoreCA2 = () => {
    navigate("/Sub-Pages/Care_Sell");
  };

   const handleReadMoreAC1 = () => {
    navigate("/Sub-Pages/Acc_Endof");
  };
  const handleReadMoreAC2 = () => {
    navigate("/Sub-Pages/Acc_Payroll");
  };
  const handleReadMoreAC3 = () => {
    navigate("/Sub-Pages/Acc_Capital");
  };
  const handleReadMoreAC4 = () => {
    navigate("/Sub-Pages/Acc_Financial");
  };
 const handleReadMoreSoft1 = () => {
    navigate("/Sub-Pages/Soft_Rota");
  };
  const handleReadMoreSoft2 = () => {
    navigate("/Sub-Pages/Soft_Governance");
  };
  const handleReadMoreSoft3 = () => {
    navigate("/Sub-Pages/Soft_Audit");
  };
  const handleReadMoreSoft4 = () => {
    navigate("/Sub-Pages/Soft_ERP");
  };
  const handleReadMoreSoft5 = () => {
    navigate("/Sub-Pages/Soft_Allowances");
  };
  const handleReadMoreOpra1 = () => {
    navigate("/Sub-Pages/Opera_Setup");
  };
    const handleReadMoreOpra2 = () => {
    navigate("/Sub-Pages/Opera_fullManag");
  };

  const location = useLocation();
  const [activeSection, setActiveSection] = useState("cqc-services");

  useEffect(() => {
    if (location.state?.activeSection) {
      setActiveSection(location.state.activeSection);
    }
  }, [location]);

  return (
    <section className="OurServices">
                <h1 className="OurServices-title">Building Confidence in Compliance</h1>
              <p className="OurServices-pera">Total Care Advisory delivers trusted consultancy that care providers can rely on when it matters most.<br/><br/>
              We understand the pressures of a busy care environment and provide expert guidance that helps services stay compliant, improve standards, and 
              move forward with confidence.</p>
              <div className="btn-container">
                 <button className="OurServices-btn">
                   <a link href="https://flipbook.so/flip/jUUmHzGAoWFTRgkf2a8U">link to Brochure</a>
                 </button>
                 </div>
               <section className="our-services">
                 <h2 className="our-services__heading">Services</h2>

               <p className="our-services__description">
                 We offer a range of specialized services tailored to meet your individual
                 needs. Our approach is focused on understanding
                 <br />
                   and responding to what you require, providing effective and practical
                 solutions.
                 </p>

                 <div className="our-services__container">
                   <div className="our-services__list">

                   <div className="our-services__item">
                     <div className="service-card">
                       <div className="service-card__image service-card__CQCServices"></div>

                      <div className="service-card__content">
                         <div className="service-card__title">CQC Services</div>

                         <p className="service-card__text">
                           We can support with the complexities of compliance and regulation!
                         </p>
                       <div className="btn-container">
                      <button onClick={() => scrollToSection("cqc-services")}
                      id="Service-btn"className={activeSection === "cqc-services" ? "active" : ""}>Read More</button>                          
                    </div>
                      </div>
                    </div>
                  </div>
                  <div className="our-services__item">
                    <div className="service-card">
                      <div className="service-card__image service-card__CareHomeSales"></div>

                      <div className="service-card__content">
                        <div className="service-card__title">Care Home Sales</div>

                        <p className="service-card__text">
                          Professional support for buying, selling, and valuing care homes.
                        </p>
                      <div className="btn-container">
                      <button onClick={() => scrollToSection("care-home-sales")}
                      id="Service-btn"className={activeSection === "care-home-sales" ? "active" : ""}>Read More</button>
                    </div>
                      </div>
                    </div>
                  </div>
                  <div className="our-services__item">
                    <div className="service-card">
                      <div className="service-card__image service-card__Accounting"></div>

                      <div className="service-card__content">
                        <div className="service-card__title">Accounting</div>

                        <p className="service-card__text">
                        Financial management, bookkeeping, payroll, and tax services.
                        </p>
                      <div className="btn-container">
                     <button onClick={() => scrollToSection("accounting")}
                    id="Service-btn"className={activeSection === "accounting" ? "active" : ""}>Read More</button>
                    </div>
                      </div>
                    </div>
                  </div>
                  <div className="our-services__item">
                    <div className="service-card">
                      <div className="service-card__image service-card__Software"></div>

                      <div className="service-card__content">
                        <div className="service-card__title">Software</div>

                        <p className="service-card__text">
                        Digital solutions designed to streamline care operations.
                        </p>
                        <div className="btn-container">
                      <button onClick={() => scrollToSection("software")}
                    id="Service-btn"className={activeSection === "software" ? "active" : ""}>Read More</button>
                    </div>
                      </div>
                    </div>
                  </div>
                  <div className="our-services__item">
                    <div className="service-card">
                      <div className="service-card__image service-card__OperationalManagement"></div>

                      <div className="service-card__content">
                        <div className="service-card__title">Operational Management</div>

                        <p className="service-card__text">
                        Guidance and support to improve efficiency and quality.
                        </p>
                        <div className="btn-container">
                         <button onClick={() => scrollToSection("Operational_Management")}
                          id="Service-btn"className={activeSection === "Operational_Management" ? "active" : ""}>Read More</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
               </section>
      
      {activeSection === "Services-Home-page"  && (
       <div className="detail-content" id="Serv">
        <div className="Support-page">
         <div className="Support-card">
          <h1 className="Support-title">We can also support with...</h1>
           <div className="Support-container">

                             <section className="Support-section">
                                 <div className="Support-image">
                                     <img src={Img1} alt="" />
                                 </div>
                                <div className="Support-box">
                                    <h2>CQC Services</h2>
                                    <p> Our expert consultants guide you through every stage of the Care Quality Commission (CQC) process, from registration 
                                      and compliance to inspections and ongoing quality improvement. We help ensure your service meets regulatory standards with confidence.</p>
                                      <button  onClick={() => navigateToService("cqc-services")}
                                        id="Service-btn" className={activeSection === "cqc-services" ? "active" : ""}>
                                            Read More </button>
                                      
                                </div>
                            </section>
                              <section className="Support-section reverse">
                                <div className="Support-image">
                                    <img src={care1} alt="" />
                                </div>
                                <div className="Support-box">
                                    <h2>Care Home Sales</h2>
                                    <p> Our Care Home Sales service provides expert guidance throughout the buying and selling process, helping owners 
                                      maximise value, ensure compliance, and achieve smooth, confidential transactions with confidence and clarity.</p>
                                      <button  onClick={() => navigateToService("care-home-sales")}
                                        id="Service-btn" className={activeSection === "care-home-sales" ? "active" : ""}>
                                            Read More </button>
                                </div>
                            </section>
                            <section className="Support-section ">
                                <div className="Support-image">
                                    <img src={Acco1} alt="" />
                                </div>
                                <div className="Support-box">
                                    <h2>Accountancy Services </h2>
                                    <p> Our specialist Accountancy Services for the care industry provide tailored financial support, helping providers manage
                                        finances efficiently, maintain compliance, improve profitability, and make informed decisions for sustainable long-term growth.</p>
                                       <button  onClick={() => navigateToService("accounting")}
                                        id="Service-btn" className={activeSection === "accounting" ? "active" : ""}>
                                            Read More </button>
                                </div>
                            </section>
                            <section className="Support-section reverse">
                                <div className="Support-image">
                                    <img src={Soft1} alt="" />
                                </div>
                                <div className="Support-box">
                                    <h2>Software</h2>
                                    <p> Our care sector software solutions streamline scheduling, governance, auditing. Our full ERP system provides all-round 
                                      efficiency to maintain compliance, enhance oversight, and deliver better outcomes across their organisations.</p>
                                      <button  onClick={() => navigateToService("software")}
                                        id="Service-btn" className={activeSection === "software" ? "active" : ""}>
                                            Read More </button>
                                </div>
                            </section>
                              <section className="Support-section">
                                <div className="Support-image">
                                    <img src={Opra1} alt="" />
                                </div>
                                <div className="Support-box">
                                    <h2>Training </h2>
                                    <p> We deliver face-to-face training for care professionals, covering moving and handling, medication, fire safety, and first aid,
                                        helping teams build confidence, stay compliant, and deliver safe, high-quality care.</p>
                                      <button  onClick={() => navigateToService("Operational_Management")}
                                        id="Service-btn" className={activeSection === "Operational_Management" ? "active" : ""}>
                                            Read More </button>
                                </div>
                            </section>
                        </div>
                    </div>
            </div>
              </div>
      )}
    </section>
  );
};

export default Services;